import { Input } from "antd";
import styled from "styled-components";

const { TextArea } = Input;

export const TextAreaFieldStyle = styled(TextArea)`
`;


